<div class="sidebar" [ngClass]="{'hidden': isAboutPage || hideSidebar}">
  <nav class="menu">

    <!-- Teams -->
    <button class="menu-item" routerLink="/teams" (click)="toggleTeamsSubmenu()">
      <span class="material-symbols-outlined">groups</span>
      <span class="label">{{ 'teams' | translate }}</span>
      <span class="material-symbols-outlined arrow" [class.open]="showTeamsSubmenu">expand_more
      </span>
    </button>

    <!-- Teams Submenu -->
    <div class="submenu" *ngIf="showTeamsSubmenu">
      <button
        class="submenu-item"
        routerLink="/teams"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-symbols-outlined">list</span>
        <span class="label">{{ 'list' | translate }}</span>
      </button>

      <button
        class="submenu-item"
        routerLink="/teams/ranking"
        routerLinkActive="active"
      >
        <span class="material-symbols-outlined">trophy</span>
        <span class="label">{{ 'ranking' | translate }}</span>
      </button>
    </div>

    <!-- Events -->
    <button class="menu-item" routerLink="/events" routerLinkActive="active">
      <span class="material-symbols-outlined">event</span>
      <span class="label">{{ 'events' | translate }}</span>
    </button>

    <!-- Profile -->
    <button
      class="menu-item"
      [routerLink]="['/profile/activities', currentUser?.uid]"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <span class="material-symbols-outlined">person</span>
      <span class="label">{{ 'me' | translate }}</span>
    </button>

    <button class="menu-item" routerLink="/profile/friends" routerLinkActive="active">
      <span class="material-symbols-outlined">group</span>
      <span class="label">{{ 'friends' | translate }}</span>
    </button>

    <button class="menu-item" routerLink="/profile/ranking" routerLinkActive="active">
      <span class="material-symbols-outlined">trophy</span>
      <span class="label">{{ 'ranking' | translate }}</span>
    </button>

    <!-- TODO -> Descomentar para abilitar as funcionalidades dos benefícios -->

    <!-- <button class="menu-item" routerLink="/benefits/redeem" routerLinkActive="active">
      <span class="material-symbols-outlined">cards_stack</span>
      <span class="label">{{ 'benefits' | translate }}</span>
    </button>

    @if(isAuthUserBusiness){
      <button class="menu-item" routerLink="/benefits/create" routerLinkActive="active">
      <span class="material-symbols-outlined">sell</span>
        <span class="label">Add {{ 'benefits' | translate }}</span>
      </button>
    } -->

    @if(isAuthUserAuthority){
      <button class="menu-item" routerLink="/spotted/places" routerLinkActive="active">
        <span class="material-symbols-outlined">docs</span>
        <span class="label">{{ 'spottedPlaces' | translate }}</span>
      </button>
      <button class="menu-item" routerLink="/quests" routerLinkActive="active">
        <span class="material-symbols-outlined">trail_length</span>
        <span class="label">{{ 'quests' | translate }}</span>
      </button>
    }

    @if(isAuthUserAdmin){
      <button class="menu-item" routerLink="/roles/management" routerLinkActive="active">
        <span class="material-symbols-outlined">manage_accounts</span>
        <span class="label">{{ 'roles' | translate }}</span>
      </button>
    }
      
  </nav>
  
  @if (showHappyHolydays) {
    <img src="happy-holidays.png" alt="Happy Holydays" class="happy-holidays">
  }

</div>
